<template>
  <div>
    <div
      class="modal fade slide-in-top"
      :id="id"
      tabindex="-1"
      role="dialog"
      aria-labelledby="create-friend-group-add-friends"
      aria-hidden="true"
    >
      <div
        class="modal-dialog window-popup create-friend-group create-friend-group-add-friends"
        :class="[{ 'modal-increase-size': increaseSize === true }]"
        role="document"
      >
        <div class="modal-content md-elevation-20">
          <div v-if="imgHeaderPath" class="modal-header-img p-2 md-elevation-1">
            <img :src="imgHeaderPath" alt="Header" class="header-img fit_cover" />
            <a
              href="#"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeButton"
              :data-cy="`${dataCy}-closeBtn`"
            >
            </a>
          </div>
          <div v-else class="modal-header p-2 md-elevation-1">
            <h4 class="modal-title mt-2">{{ title }}</h4>
            <a
              data-dismiss="modal"
              aria-label="Close"
              ref="closeButton"
              :data-cy="`${dataCy}-closeBtn`"
            >
              <md-button class="md-icon-button" @click="closeModal">
                <md-icon class="close-modal">close</md-icon>
              </md-button>
            </a>
          </div>
          <div class="modal-body text-center">
            <slot name="default"></slot>
          </div>
          <div class="text-center">
            <slot name="footer" class="modal-footer">
              <SButton
                v-if="isBackButton && backButtonVisible"
                :text="backButtonName"
                color="primary"
                size="md"
                :class="['mr-3',{'cancel-button': backButtonRed}]"
                class="btn-size"
                @button="$emit('back')"
                :disabled="backButtonDisabled"
                :data-cy="`${dataCy}-backBtn`"
              />
              <SButton
                v-if="buttonName && !materialButton"
                :text="buttonName"
                color="blue"
                size="md"
                class="text-white btn-size"
                @button="$emit('button')"
                :disabled="disabled"
                :data-cy="`${dataCy}-btn`"
              />
              <SButtonMaterial
                v-if="buttonName && materialButton"
                buttonType="button"
                class="mb-4 btn-size bt-1"
                color="white"
                textColor="primary"
                borderColor="primary"
                materialClass="dense"
                :text="buttonName"
                @button="$emit('button')"
                :disabled="disabled"
                :data-cy="`${dataCy}-btn`"
              />
              <SButtonMaterial
                v-if="buttonRegisterName"
                buttonType="button"
                class="btn-size .bt-2"
                color="primary"
                textColor="white"
                materialClass="dense"
                @button="$emit('register')"
                :text="buttonRegisterName"
                :data-cy="`${dataCy}-btn`"
              />
              <span v-if="canSkip" class="skip" @click="$emit('skip')">
                Skip
              </span>
            </slot>
          </div>
          <div class="text-center">
            <slot name="afterButton"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SButton from "@/components/atoms/SButton";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
export default {
  name: "Modal",
  model: {
    prop: "input",
    event: "change",
  },
  components: {
    SButton,
    SButtonMaterial,
  },
  props: [
    "buttonName",
    "buttonRegisterName",
    "title",
    "id",
    "disabled",
    "arrow",
    "isBackButton",
    "backButtonName",
    "backButtonDisabled",
    "backButtonVisible",
    "canSkip",
    "dataCy",
    "materialButton",
    "isBackArrow",
    "backArrowVisible",
    "arrowBackText",
    "backArrowDisabled",
    "increaseSize",
    "imgHeaderPath",
    "backButtonRed"
  ],
  methods: {
    closeModal() {
      this.$refs.closeButton.click();
      this.$emit('resetModalWhenClose')
      if(this.id==="register")
        this.$router.push('/');
    },
  },
  mounted() {
    $(`#${this.id}`).on("show.bs.modal", () => {
      this.$emit("show");
    });
    $(`#${this.id}`).on("shown.bs.modal", () => {
      this.$emit("shown");
    });
    $(`#${this.id}`).on("hide.bs.modal", () => {
      this.$emit("hide");
    });
    $(`#${this.id}`).on("hidden.bs.modal", () => {
      this.$emit("hidden");
    });
  },
};
</script>

<style lang="scss" scoped>

.bt-1{
      margin-right: 1em
}
.bt-2{
      margin-left: 1em
}

.cancel-button{
  color: brown !important;
  border: none;
}
.btn-size {
  min-height: 32px;
  max-height: 32px;
  min-width: 115px;
}
.skip {
  position: absolute;
  right: 23px;
  bottom: 12px;
}
.skip:hover {
  color: $primary;
  cursor: pointer;
}
.modal-header {
  background-color: $primary;
  border: 0 !important;
  border-radius: 3px;
}
.modal-dialog {
  color: $dark;
}
.modal-content {
  border: 0 !important;
}
.modal {
  top: 2vw !important;
}
.modal-title {
  margin-left: 0.8rem;
  color: $white;
}
footer {
  margin-top: 3rem;
  margin-bottom: 2rem;
}
.close-modal {
  color: $white !important;
}
p,
span {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1.25px;
  color: $black-sub-color;
}
h4 {
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 1.25px;
}
.previous-btn-margin {
  margin-right: 16px;
}
</style>

<style lang="scss" scoped>
.slide-in-top {
  -webkit-animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
/* ----------------------------------------------
 * Generated by Animista on 2022-1-31 11:13:13
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-in-top
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slide-in-top {
  0% {
    -webkit-transform: translateY(-1000px);
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-increase-size {
  width: 680px;
}

.header-img {
  height: 200px;
  width: 260px;
  max-width: 1268px;
  margin: auto;
  display: block;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.modal-header-img {
  background-color: $primary;
  border: 0 !important;
  border-radius: 3px;
}

.modal-header-img:after {
  content: "";
  display: block;
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  height: 10px;
  background: linear-gradient(60deg, transparent 50%, #05919b 50%),
    linear-gradient(-60deg, transparent 50%, #05919b 50%);
  background-size: 25px 15px;
  background-position: 0px -5px;
}

#welcome-notice .modal-header-img {
  transform: translatex(0px) translatey(0px);
}
</style>
